import {
  Component,
  OnInit,
  AfterViewInit,
  TemplateRef,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { filter, Subscription } from 'rxjs';
import { NavService } from '../../services/nav.service';
import { SidebarRightService } from '../../services/sidebar-right.service';
import { SwitcherService } from '../../services/switcher.service';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { NavigationEnd, Router } from '@angular/router';
import { TokenStorageService } from '../../services/token-storage.service';
import { TopbarService } from '../../services/topbar.services';
import { DashboardService } from '../../services/dashboard.services';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})

export class HeaderComponent implements OnInit {
  private gettopbarValue!: Subscription;
  layoutSubscription: Subscription;
  searchData: string = '';
  topbarDetails: any;
  public isCollapsed = true;
  themeType = 'dark';
  public text!: string;
  currentUserDetail: any;
  companyDetail: any;
  companyCode: string = '';
    private routeSub!: Subscription;

  constructor(
    private sidebarRightservice: SidebarRightService,
    public navServices: NavService,
    public SwitcherService: SwitcherService,
    public offcanvasService: NgbOffcanvas,
    public el: ElementRef,
    public elementRef: ElementRef,
    public renderer: Renderer2,
    private router: Router,
    public tokenStorage: TokenStorageService,
    private topbar: TopbarService,
    private dashboard: DashboardService,
    private ts: ToastrService,
  ) {
    this.layoutSubscription = sidebarRightservice.changeEmitted.subscribe(
      (direction) => {
        const dir = direction.direction;
      }
    );

    const windowObject: any = window;
    if (windowObject.innerWidth <= '991') {
      document.querySelector('html')?.setAttribute('data-toggled', 'close');
    } else {
      document.querySelector('html')?.removeAttribute('data-toggled');
    }
  }

   isFullscreen: boolean = false;

  toggleFullscreen() {
    this.isFullscreen = !this.isFullscreen;
  }

  ngOnInit(): void {
    this.currentUserDetail = JSON.parse(localStorage.getItem('currentUser') as string);
    this.tokenStorage.setCompanyCode(this.currentUserDetail?.customerShortName ? this.currentUserDetail?.customerShortName : '')
    this.companyCode = this.tokenStorage?.getCompanyCode() ? this.tokenStorage?.getCompanyCode() : '';

    // this.tokenStorage.companyCode.next(this.companyCode);

    // this.tokenStorage.companyCode$.subscribe(res => {
    //   if(res && res !== null && res !== undefined){
    //     this.companyCode = res;
    //   }
    // })

    //  this.routeSub = this.router.events
    //   .pipe(filter(event => event instanceof NavigationEnd))
    //   .subscribe(() => {
        this.getCompanyProfile( this.currentUserDetail.infraCustomerCustomerId && this.currentUserDetail.infraCustomerCustomerId !== null && Number(this.currentUserDetail.infraCustomerCustomerId) > 0 ? this.currentUserDetail.infraCustomerCustomerId : this.currentUserDetail.customerId && this.currentUserDetail.customerId !== null && Number(this.currentUserDetail.customerId) > 0 ? this.currentUserDetail.customerId :0)
      // });
    // console.log(this.currentUserDetail.customerId)

    if(this.currentUserDetail == null || this.currentUserDetail == undefined){
      this.router.navigate(['/signin'])
    }

    // if(this.currentUserDetail.customerId == null || this.currentUserDetail.customerId == 0 || this.currentUserDetail.customerId == '' ){
    //   this.router.navigate(['/signin'])
    // }

    this.gettopbarValue = this.topbar.topbarDetailsValue$.subscribe(res => {
      if (res && Object.keys(res).length > 0) {
        this.topbarDetails = res;
        this.searchData = ''
        // this.cdref.detectChanges();
      }
    })

    let navbarForm: any = document.querySelector('.navbar-form');
    if (navbarForm) {
      navbarForm.addEventListener(
        'click',
        (event: any) => {
          event.preventDefault();
          return;
        },
        { passive: false }
      );
    }
  }

    getCompanyProfile(customerId: number) {
    this.dashboard.getCompanyProfile(customerId).subscribe({
      next: (res) => {
        if (res && res?.success) {
          if (res && res.data) {
            this.companyDetail = res.data
            setTimeout(() =>{
              this.companyCode = res.data.companyProfile && res.data.companyProfile !== null && res.data.companyProfile.companyCode && res.data.companyProfile.companyCode !== null ? res.data.companyProfile.companyCode : ''
            }, 100)
            // console.log(this.companyDetail)
            // const base64FromApi = this.companyDetail.companyProfile.logo;
            // this.logoUrl = `data:image/png;base64,${base64FromApi}`
          } else {
            this.ts.warning(res.message)
          }
        } else {
          this.ts.warning(res.message)
        }
      }, error: (err) => {
        console.error('Api Error:', err);
        this.ts.error(err?.error?.message || 'Something went Wrong')
      }
    })
  }

  toggleSwitcher() {
    this.SwitcherService.emitChange(true);
    let html = this.elementRef.nativeElement.ownerDocument.documentElement;
    if (html?.getAttribute('data-toggled') == 'open' ) {
      document.querySelector('#responsive-overlay')?.classList.add('active');
    } else {
      document.querySelector('#responsive-overlay')?.classList.remove('active');
    }
   
  }

  toggleSidebarNotification() {
    this.sidebarRightservice.emitSidebarNotifyChange(true);
  }

  togglesidebar() {
    let html = this.elementRef.nativeElement.ownerDocument.documentElement;
    if (localStorage.getItem('data-toggled') == 'true') {
      document.querySelector('html')?.getAttribute('data-toggled') ==
        'icon-overlay-close';
    } else if (html?.getAttribute('data-vertical-style') == 'overlay') {
      document.querySelector('html')?.getAttribute('data-toggled') != null
        ? document.querySelector('html')?.removeAttribute('data-toggled')
        : document
            .querySelector('html')
            ?.setAttribute('data-toggled', 'icon-overlay-close');
    } else if (localStorage.getItem('valexverticalstyles') == 'closed') {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'close-menu-close'
          ? ''
          : 'close-menu-close'
      );
    } else if (localStorage.getItem('valexverticalstyles') == 'icontext') {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'icon-text-close'
          ? ''
          : 'icon-text-close'
      );
    } else if (localStorage.getItem('valexverticalstyles') == 'detached') {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'detached-close'
          ? ''
          : 'detached-close'
      );
    } else if (localStorage.getItem('valexverticalstyles') == 'doublemenu') {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'double-menu-close'
          ? 'double-menu-open'
          : 'double-menu-close'
      );
    }

    if (window.innerWidth <= 992) {
      html?.setAttribute(
        'data-toggled',
        html?.getAttribute('data-toggled') == 'open' ? 'close' : 'open'
      );
      // if (html?.getAttribute('data-toggled') == 'open') {
      //   document.querySelector('#responsive-overlay')?.classList.add('active');
      // }
    }
  }

  //  toggleSidebar() {
  //   let html = this.elementRef.nativeElement.ownerDocument.documentElement;
  //   if(window.innerWidth <= 992){
  //     html?.setAttribute('toggled', html?.getAttribute('toggled') == 'open' ? 'close' : 'open');
  //     if(html?.getAttribute('toggled') == 'open'){
  //       document.querySelector('#responsive-overlay')?.classList.add('active');
  //     }else{
  //       document.querySelector('#responsive-overlay')?.classList.remove('active');
  //     }
  //   }
  //   else if (!localStorage.getItem('synto-menu-styles')) {
  //     html?.setAttribute('toggled', html?.getAttribute('toggled') == 'icon-overlay-close' ? '' : 'icon-overlay-close');
  //   } else {
  //     if (localStorage.getItem('synto-menu-styles') == 'menu-click') {
  //       html?.setAttribute('toggled', html?.getAttribute('toggled') == 'menu-click-closed' ? '' : 'menu-click-closed');
  //     }
  //     if (localStorage.getItem('synto-menu-styles') == 'menu-hover') {
  //       html?.setAttribute('toggled', html?.getAttribute('toggled') == 'menu-hover-closed' ? '' : 'menu-hover-closed');
  //     }
  //     if (localStorage.getItem('synto-menu-styles') == 'icon-click') {
  //       html?.setAttribute('toggled', html?.getAttribute('toggled') == 'icon-click-closed' ? '' : 'icon-click-closed');
  //     }
  //     if (localStorage.getItem('synto-menu-styles') == 'icon-hover') {
  //       html?.setAttribute('toggled', html?.getAttribute('toggled') == 'icon-hover-closed' ? '' : 'icon-hover-closed');
  //     }
  //   }
  // }

  themeChange(type: string, type1: string) {
    const htmlElement =
      this.elementRef.nativeElement.ownerDocument.documentElement;
    this.renderer.setAttribute(htmlElement, 'data-header-styles', type1);
    localStorage.setItem('valexHeader', type1);
    this.renderer.setAttribute(htmlElement, 'data-menu-styles', type1);
    localStorage.setItem('valexMenu', type1);
    this.renderer.setAttribute(htmlElement, 'data-theme-mode', type1);
    localStorage.setItem('valexdarktheme', type1);
    this.elementRef.nativeElement.ownerDocument.documentElement?.removeAttribute(
      'style'
    );

    const darkBtn = document.querySelector(
      '#switcher-dark-theme'
    ) as HTMLInputElement;
    const lightBtn = document.querySelector(
      '#switcher-light-theme'
    ) as HTMLInputElement;

    if (this.themeType === 'dark' && darkBtn) {
      darkBtn.checked = true;
    } else if (this.themeType === 'light' && lightBtn) {
      lightBtn.checked = true;
    }
  }
 

  search() {
    let navabarForm: any = document.querySelector('.navbar-form ');
    navabarForm.classList.toggle('d-none');
  }
  close() {
    let navbarD: any = document.querySelector('.navbar-form ');
    navbarD.classList.add('d-none');
  }

  ngOnDestroy(): void {
    const windowObject: any = window;
    let html = this.elementRef.nativeElement.ownerDocument.documentElement;
    if (windowObject.innerWidth <= '991') {
      html?.setAttribute('data-toggled', 'open');
    }
    window.addEventListener('resize', () => {
      if (localStorage.getItem('valexverticalstyles') != 'icon-text-close') {
        if (windowObject.innerWidth <= '991') {
          html?.setAttribute('data-toggled', 'open');
        } else {
          if (!(localStorage.getItem('valexverticalstyles') == 'doublemenu')) {
            html?.removeAttribute('data-toggled');
          }
        }
      } else {
        document
          .querySelector('html')
          ?.setAttribute('data-toggled', 'icon-text-close');
      }
    });

    if (windowObject.innerWidth <= '991') {
      html?.setAttribute('data-toggled', 'open');
    }
    
  }

  SearchActive = 'Notactive';
  searchClass(item: any) {
    console.log(item);
    if (item == 'active') {
      this.SearchActive = 'active';
    }
    if (item == 'Notactive') {
      this.SearchActive = 'Notactive';
    }
  }

  redirectTologin(){
    this.tokenStorage.signOut();
    this.router.navigate(['/signin'])
  }
}

